import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddTyreDetails = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [vehicle, setVehicle] = useState([]);
  const [Company, setCompany] = useState([]);
  const [Staff, setStaff] = useState([]);
  // console.log(Material)
  const [rowAddData, setRowAddData] = useState({
    received_date: "",
    new_tyre_num: "",
    old_tyre_num: "",
    new_purchase_date: "",
    start_km: "",
    current_km: "",
    running_km: "",
    tyre_brand: "",
    quality_status: "",
  });
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  function resetFileds() {
    setRowAddData({
      received_date: "",
      new_tyre_num: "",
      old_tyre_num: "",
      new_purchase_date: "",
      start_km: "",
      current_km: "",
      running_km: "",
      tyre_brand: "",
      quality_status: "",
    });
    setSelectedStaffId("");
    setSelectedVehicleId("");
    setSelectedCompanyId("");
  }

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      received_date,
      new_tyre_num,
      old_tyre_num,
      new_purchase_date,
      start_km,
      current_km,
      running_km,
      tyre_brand,
      quality_status,
    } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/tyre/tyre-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        vehicle_id: selectedVehicleId,
        driver_id: selectedStafflId,
        new_tyre_num,
        old_tyre_num,
        start_km,
        current_km,
        running_km,
        tyre_brand,
        quality_status,
        received_date: moment(received_date).format("YYYY-MM-DD"),
        new_purchase_date: moment(new_purchase_date).format("YYYY-MM-DD"),
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        resetFileds();
        getData();
        // formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getStaff = async (e) => {
    // console.log(e.target.value)
    setSelectedCompanyId(e.target.value);
    const companyID = e.target.value;
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyID}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Tyre Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getStaff(e)}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {Company &&
                                Company?.length > 0 &&
                                Company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="staff_id">Driver Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={selectedStafflId}
                              id="staff_id"
                              required
                            >
                              <option value="">Select Driver Name</option>
                              {Staff &&
                                Staff?.length > 0 &&
                                Staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="material_name">
                              Vehicle Number
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleVehicleChange}
                              value={selectedVehicleId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.vehicle_number}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="received_date">Received Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="received_date"
                              id="received_date"
                              placeholder="Received Date"
                              onChange={handleChange}
                              value={rowAddData.received_date}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="new_tyre_num">
                              New Tyre Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="new_tyre_num"
                              id="new_tyre_num"
                              placeholder="New Tyre Number"
                              onChange={handleChange}
                              value={rowAddData.new_tyre_num}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="old_tyre_num">
                              Old Tyre Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="old_tyre_num"
                              id="old_tyre_num"
                              placeholder="old_tyre_num"
                              onChange={handleChange}
                              value={rowAddData.old_tyre_num}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="new_purchase_date">
                              New Purchase Date
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="new_purchase_date"
                              id="new_purchase_date"
                              placeholder="New Purchase Date"
                              onChange={handleChange}
                              value={rowAddData.new_purchase_date}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="start_km">Start KM</label>
                            <input
                              type="text"
                              className="form-control"
                              name="start_km"
                              id="start_km"
                              placeholder="Start KM"
                              onChange={handleChange}
                              value={rowAddData.start_km}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="current_km">Current KM</label>
                            <input
                              type="text"
                              className="form-control"
                              name="current_km"
                              id="current_km"
                              placeholder="Current KM"
                              onChange={handleChange}
                              value={rowAddData.current_km}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="running_km">Running KM</label>
                            <input
                              type="text"
                              className="form-control"
                              name="running_km"
                              id="running_km"
                              placeholder="Running KM"
                              onChange={handleChange}
                              value={rowAddData.running_km}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="tyre_brand">Tyre Brand</label>
                            <input
                              type="text"
                              className="form-control"
                              name="tyre_brand"
                              id="tyre_brand"
                              placeholder="Tyre Brand"
                              onChange={handleChange}
                              value={rowAddData.tyre_brand}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="quality_status">
                              Quality Status
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="quality_status"
                              id="quality_status"
                              placeholder="Quality Status"
                              onChange={handleChange}
                              value={rowAddData.quality_status}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTyreDetails;
